import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, IllusEmpty_1, Image, theme, TitleText } from '@sg/garnish';

export const NoResults = ({ message = '' }) => {
  const { formatMessage } = useIntl();

  return (
    <View style={styles.wrapper} testID="location-no-results">
      <Image source={IllusEmpty_1} style={styles.image} />

      <TitleText size={6} style={styles.title}>
        {message}
      </TitleText>

      <BodyText size={2}>{formatMessage(messages.locationTryAnotherSearch)}</BodyText>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    textAlign: 'center',
    paddingVertical: theme.spacing['10'],
    paddingHorizontal: theme.spacing['6'],
  },
  image: {
    width: 248,
    height: 248,
    resizeMode: 'contain',
  },
  title: {
    marginBottom: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  locationTryAnotherSearch: {
    defaultMessage: 'Try another search',
    description: 'Location | Try Another Search',
  },
});
